import React from 'react';

const ContactInfo = ({ language }) => {
  return (
   <div className="contact-info bg-light shadow-sm p-4 rounded">
    <h5 className="fw-bold mb-3" style={{ color: '#1e3a8a' }}>
      {language === 'en' ? 'Blue Nest Hotel' : 'ብሉ ኔስት ሆቴል'}
    </h5>
     <p className="mb-1">
      {language === 'en' ? 'Sarbet, Addis Ababa, Ethiopia' : 'ሳርቤት ፣ አዲስ አበባ፣ ኢትዮጵያ'}
    </p>

    <h6 className="mt-4 fw-bold" style={{ color: '#1e3a8a' }}>
      {language === 'en' ? 'Reservations' : 'ቦታ ማስያዝ'}
    </h6>

    <p className="mb-1">
  <a href="tel:+251911123456" className="text-decoration-none" style={{ color: '#2563eb' }}>+25 19 30 80 23 23</a>
</p>
<p className="mb-1">
  <a href="tel:+251116789012" className="text-decoration-none" style={{ color: '#2563eb' }}>+251 93 08 02 32 62</a>
</p>
<p className="mb-3">
  <a href="mailto:info@bluenesthotel.com" className="text-decoration-none" style={{ color: '#2563eb' }}>bluebesthotelsocials@gmail.com</a>
</p>

    <h6 className="fw-bold" style={{ color: '#1e3a8a' }}>
      {language === 'en' ? 'Front Desk Hours' : 'የፊት ዴስክ ሰዓት'}
    </h6>
    <p className="mb-0">
      {language === 'en' ? '24/7 Available' : '24/7 ይገኛል'}
    </p>
  </div>
  );
};

export default ContactInfo;
